import axios from 'axios';
import axiosDebounce from '@/lib/axios-debounce';

const axiosExtra = {
  setHeader(name, value, scopes = 'common') {
    (Array.isArray(scopes) ? scopes : [scopes]).forEach((scope) => {
      if (!value) {
        delete this.defaults.headers[scope][name];
        return;
      }
      this.defaults.headers[scope][name] = value;
    });
  },
  setToken(token, type, scopes = 'common') {
    const value = !token ? null : (type ? `${type} ` : '') + token;
    this.setHeader('Authorization', value, scopes);
  },
  onRequest(fn) {
    this.interceptors.request.use(config => fn(config) || config);
  },
  onResponse(fn) {
    this.interceptors.response.use(response => fn(response) || response);
  },
  onRequestError(fn) {
    // eslint-disable-next-line promise/no-promise-in-callback
    this.interceptors.request.use(undefined, error => fn(error) || Promise.reject(error));
  },
  onResponseError(fn) {
    // eslint-disable-next-line promise/no-promise-in-callback
    this.interceptors.response.use(undefined, error => fn(error) || Promise.reject(error));
  },
  onError(fn) {
    this.onRequestError(fn);
    this.onResponseError(fn);
  },
  isUnauthorized(error = {}) {
    const { response = {} } = error;
    return response.status === 401;
  },
  isUnprocessableEntity(error = {}) {
    const { response = {} } = error;
    return response.status === 422;
  },
};

function extendAxiosInstance(instance) {
  Object.keys(axiosExtra).forEach((key) => {
    instance[key] = axiosExtra[key].bind(instance); // eslint-disable-line no-param-reassign
  });
}

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

axiosDebounce(http);

extendAxiosInstance(http);

Object.assign(
  http,
  {
    Cancel: axios.Cancel,
    isCancel: axios.isCancel,
    CancelToken: axios.CancelToken,
    axios,
  },
);

export default http;
